import React from "react";
import { Form, Button, InputNumber, Input } from "antd";
import {
  ClockCircleOutlined,
  PercentageOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";

const FormBAtchRider = (props) => {
  return (
    <Form initialValues={props.initialValues} onFinish={props.onFinish}>
      <div className="customTable">
        <table>
          <thead>
            <tr>
              <th>Shift ID</th>
              <th>Shift Zone</th>
              <th>Rider ID</th>
              <th>Rider</th>
            </tr>
          </thead>
          <tbody>
            <Form.List
              name={"rider_shift_data"}
              initialValues={props.initialValues}
            >
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => {
                    return (
                      <tr key={field.key}>
                        <td>
                          <Form.Item
                            key={field.key}
                            name={[field.name, "shiftDisplayId"]}
                            // label={`${index + 1}-rider-display-id`}
                            rules={[
                              {
                                required: true,
                                message: "Shift ID is Required",
                              },
                            ]}
                          >
                            <Input placeholder="Shift Display ID" />
                          </Form.Item>
                        </td>
                        <td>
                          <Form.Item
                            key={field.key}
                            name={[field.name, "shiftZone"]}
                          >
                            <Input disabled placeholder="Shift Zone" />
                          </Form.Item>
                        </td>
                        <td>
                          <Form.Item
                            key={field.key}
                            name={[field.name, "riderDisplayId"]}
                            rules={[
                              {
                                required: true,
                                message: "Rider ID is Required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Rider Display ID"
                              // prefix={<ClockCircleOutlined />}
                            />
                          </Form.Item>
                        </td>
                        <td>
                          <Form.Item
                            key={field.key}
                            name={[field.name, "rider"]}
                          >
                            <Input disabled placeholder="Rider Zone" />
                          </Form.Item>
                        </td>
                        <td>
                          <MinusCircleOutlined
                            style={{ height: 40, color: "red" }}
                            onClick={() => remove(field.name)}
                          />
                        </td>
                        {/* </Space> */}
                      </tr>
                    );
                  })}
                </>
              )}
            </Form.List>
            {props.initialValues.rider_shift_data.length > 0 ? (
              <tr>
                <td colSpan={5}>
                  <Form.Item>
                    <Button
                      className="submit"
                      htmlType="submit"
                      loading={props.showSubmitLoder == true ? true : false}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </td>
              </tr>
            ) : (
              ""
            )}
          </tbody>
        </table>
      </div>
    </Form>
  );
};

export default FormBAtchRider;
